import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class TextDef {
  key?: string = uuid()
  type: 'text' = 'text'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: TextOptions = new TextOptions()
  rules?: Rule[]
}

export class TextOptions {
  defaultValue?: string
  disabled?: DisabledType = false
  placeholder?: string
  maxlength?: number
  labelWidth?: string | number
  required?: boolean = false
  clearable?: boolean = true
  onChange?: (options: { value: any; form: Record<string, any>; rowForm: Record<string, any> }) => void
  dataType?: 'text' | 'number' | 'date' | 'password' = 'text'
  prepend?: string
  append?: string
  pattern?: string
  labelDes?: string
  attrs?: Record<string, any>
}
